module.exports = __webpack_public_path__ + "static/media/find-a-provider-icon-active.5c12f782.svg";